export default "__VITE_ASSET__DpXJ5oZd__"